import { Star } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Ana Silva',
      location: 'Almada',
      rating: 5,
      text: 'Serviço impecável. Técnico prestável e rápido. Recomendo!'
    },
    {
      name: 'João Santos',
      location: 'Oeiras', 
      rating: 5,
      text: 'Preço justo e trabalho de qualidade. Muito satisfeito.'
    },
    {
      name: 'Maria Costa',
      location: 'Cacém',
      rating: 5,
      text: 'Atendimento excelente. Resolveram o problema no mesmo dia.'
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star 
        key={index}
        className={`w-5 h-5 ${index < rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`}
      />
    ));
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Avaliações de Clientes
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Veja o que os nossos clientes dizem sobre o nosso serviço
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="flex justify-center gap-1 mb-4">
                {renderStars(testimonial.rating)}
              </div>
              <blockquote className="text-lg text-gray-700 mb-6 italic">
                "{testimonial.text}"
              </blockquote>
              <div>
                <div className="font-semibold text-gray-900 text-lg">
                  {testimonial.name}
                </div>
                <div className="text-gray-700">
                  {testimonial.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
